import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaClipboardList, FaFileInvoice, FaSchool, FaUserGraduate } from 'react-icons/fa';
import { procurementAPI } from '../../utils/api';
import { DashboardChartGrid, KpiGrid, PortalHero } from '../../components_shared/PortalDashboard';

const empty = { tenders: 0, assignedTenders: 0, workOrders: 0, totalEnrollment: 0 };

export default function ProcurementDashboardPage() {
  const navigate = useNavigate();
  const [summary, setSummary] = useState(empty);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    procurementAPI.summary()
      .then(res => setSummary({ ...empty, ...(res.data || {}) }))
      .finally(() => setLoading(false));
  }, []);

  const cards = useMemo(() => [
    { icon: <FaFileInvoice />, label: 'Tenders', value: summary.tenders, desc: 'Total procurement tenders', onClick: () => navigate('/tenders'), className: 'eduss-dashboard-card-blue' },
    { icon: <FaClipboardList />, label: 'Assigned', value: summary.assignedTenders, desc: 'Tenders with publishers', onClick: () => navigate('/tenders'), className: 'eduss-dashboard-card-green' },
    { icon: <FaSchool />, label: 'Work Orders', value: summary.workOrders, desc: 'Generated work orders', onClick: () => navigate('/work-orders'), className: 'eduss-dashboard-card-yellow' },
    { icon: <FaUserGraduate />, label: 'Enrollment', value: Number(summary.totalEnrollment || 0).toLocaleString(), desc: 'Students captured for planning', onClick: () => navigate('/procurement/enrollment'), className: 'eduss-dashboard-card-green' },
  ], [summary, navigate]);

  const charts = useMemo(() => [
    {
      title: 'Procurement Pipeline',
      caption: 'Current totals',
      type: 'bar',
      data: [
        { name: 'Tenders', value: Number(summary.tenders || 0) },
        { name: 'Assigned', value: Number(summary.assignedTenders || 0) },
        { name: 'Orders', value: Number(summary.workOrders || 0) },
      ],
      color: '#0f6fad',
    },
    {
      title: 'Demand Movement',
      caption: 'Planning view',
      type: 'line',
      data: [
        { name: 'Enrollment', value: Number(summary.totalEnrollment || 0) },
        { name: 'Tenders', value: Number(summary.tenders || 0) },
        { name: 'Orders', value: Number(summary.workOrders || 0) },
      ],
      color: '#10ac84',
    },
  ], [summary]);

  return (
    <div className="eduss-dashboard">
      <PortalHero title="Procurement Dashboard" subtitle="Track enrollment demand, tender assignment, and work order generation." />
      <KpiGrid cards={cards} loading={loading} />
      <DashboardChartGrid charts={charts} />
    </div>
  );
}
